import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Container, Alert, Snackbar } from '@mui/material'
import MUISignIn from '../components/Auth/MUISignIn'
import { useAuth } from '../context/AuthContext'

function Login() {
  const { currentUser } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'error' })

  useEffect(() => {
    // Redirect if user is already logged in
    if (currentUser) {
      navigate('/')
    }

    // Check for URL parameters indicating account lockout
    const searchParams = new URLSearchParams(location.search)
    const isLocked = searchParams.get('locked') === 'true'
    const lockMessage = searchParams.get('message')

    if (isLocked && lockMessage) {
      setNotification({
        open: true,
        message: decodeURIComponent(lockMessage),
        severity: 'error',
      })
    }
  }, [currentUser, navigate, location])

  const handleAuthStateChange = (user) => {
    if (user) {
      navigate('/')
    }
  }

  const handleCloseNotification = () => {
    setNotification({
      ...notification,
      open: false,
    })
  }

  return (
    <Container component='main' maxWidth='xs'>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <MUISignIn onAuthStateChange={handleAuthStateChange} />
        <Snackbar
          open={notification.open}
          autoHideDuration={6000}
          onClose={handleCloseNotification}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseNotification} severity={notification.severity}>
            {notification.message}
          </Alert>
        </Snackbar>
      </Box>
    </Container>
  )
}

export default Login
